import React from 'react';
import './Openaccount.css'; 

function Openaccount() {
  return (
    <div className='container mt-5'>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <div className='row text-center mb-5'>
        <h1 className='mb-4'>Open a Zerodha account</h1>
        <p className='mb-4'>Modern platforms and apps, ₹0 investments, and flat ₹20 intraday and F&O trades.</p>
        <button className='btn btn-primary' style={{margin: "0 auto"}}>Sign up now</button>
      </div>
      <br/>
      <br/>
      <br/>
    </div>
  );
}

export default Openaccount;
